"use client";

import { Facebook, Twitter, Linkedin, Instagram } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6">
        <div className="h-5 w-16 bg-muted-light/30 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted-light/30 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted-light/30 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted-light/30 animate-pulse rounded" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="gap-6">
        {menuItems.slice(0, 4).map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-sm font-medium text-foreground-dark hover:text-accent relative group transition-colors duration-[80ms]">
                {item.label}
                <span className="absolute left-0 bottom-[-2px] w-0 h-[2px] bg-accent transition-all duration-[150ms] ease-out group-hover:w-full" />
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const socialLinks = [{
    icon: Facebook,
    href: "https://facebook.com",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "https://twitter.com",
    label: "Twitter"
  }, {
    icon: Linkedin,
    href: "https://linkedin.com",
    label: "LinkedIn"
  }, {
    icon: Instagram,
    href: "https://instagram.com",
    label: "Instagram"
  }];
  return <footer ref={ref} className={`bg-dark-background py-6 border-t border-border transition-all duration-[150ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-sm text-foreground-dark order-2 md:order-1">
            © {new Date().getFullYear()} Coastal AI & Technology LLC. All rights reserved.
          </div>

          <div className="order-1 md:order-2">
            <MenuProvider menu_id="17">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          <div className="flex items-center gap-4 order-3">
            {socialLinks.map((social, i) => {
            const Icon = social.icon;
            return <Link key={social.label} to={social.href} newTab className="text-foreground-dark hover:text-accent transition-colors duration-[80ms]" aria-label={social.label} data-index={i}>
                  <Icon className="size-5" />
                </Link>;
          })}
          </div>
        </div>
      </div>
    </footer>;
}